<!-- Index-1 component -->
<script>
	
	import Navbar from '../../Components/Navbar.svelte';

    import HomeSection from '../Layout1/HomeSection.svelte';
	import Client from '../../Components/Client.svelte';
	import Services from '../../Components/Services.svelte';
	import Incidencias from '../../Components/Incidencia.svelte';

	import Footer from '../../Components/Footer.svelte';
	//import Switcher from './../../Components/Switcher.svelte';
	import Contact from '../../Components/Contact.svelte';
	import data from '../../Data/data';

</script>

<!-- STRAT NAVBAR -->
<Navbar extraclass="navbar-white" />
<!-- END NAVBAR -->
<HomeSection />
<Client />
<!-- <Incidencias /> -->
<Services serviceData={data.SERVICE_DATA} websiteData={data.WEBSITE_DESCRIPTION} />
<Contact />
<Footer />
<!-- <Switcher /> -->
